import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MedicalBillEditorComponent } from '../medical-bill-editor/medical-bill-editor.component';
import { TealCompEncounterDetails } from '../../../models/encounter';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { MedicalBillInsert, MedicalBillLineInsert, MedicalBillLineUpdate, MedicalBillUpdate } from '@harlowe/core';
import { ButtonModule } from 'primeng/button';
import { plainToInstance } from 'class-transformer';
import { InvalidLocationError, LocationService } from '@harlowe/core';
import { LocationInsert } from '@harlowe/core';
import { ProviderLocationIdentifier } from '@harlowe/core';
import { FileUploadHandlerEvent, FileUploadModule } from 'primeng/fileupload';
import { EncounterService } from '../../../services/encounter.service';
import { CardModule } from 'primeng/card';
import { MenuModule } from 'primeng/menu';
import { MenuItem, MessageService } from 'primeng/api';
import { UtilService } from '@harlowe/core';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { MedicalService } from '@harlowe/core';
import { MedicalBillRepricerComponent } from '../medical-bill-repricer/medical-bill-repricer.component';
import { IDiagnosis } from '@harlowe/core';
import { Store } from '@ngxs/store';
import { UserInterface } from '../../../state/ui/ui-actions';
import { BlockUI } from '@harlowe/core';
import { TealCompMedicalService } from '../../../services/medical.service';
import { IMedicalBill, MedicalBill } from '../../../models/medical-bill';


@Component({
  selector: 'app-encounter-medical-bill-block',
  standalone: true,
  imports: [MedicalBillEditorComponent,NgIf,PanelModule,ButtonModule,
            FileUploadModule,MenuModule,PanelModule,FloatLabelModule,
            CardModule,InputNumberModule,FormsModule,CheckboxModule,
            NgFor,MedicalBillRepricerComponent,DatePipe],
  templateUrl: './encounter-medical-bill-block.component.html',
  styleUrl: './encounter-medical-bill-block.component.scss'
})
export class EncounterMedicalBillBlockComponent 
{
  private _encounter : TealCompEncounterDetails | undefined
  get encounter(): TealCompEncounterDetails | undefined
  {
    return this._encounter;
  }
  @Input() set encounter(val: TealCompEncounterDetails | undefined )
  {
    this._encounter = val;
    this.medicalBills = [];
    if(val && val.primaryMedicalBill)
    {
      this.medicalBills = [val.primaryMedicalBill,...val.additionalMedicalBills];
    }
  }

  // @ViewChild('editBill') editBill!: ElementRef; 
  // @ViewChild('newBill') newBill!: ElementRef; 
  @ViewChild('editDiv') editDiv!: ElementRef; 


  get encounterScheduled() : boolean
  {
    return (this.encounter?.status ?? -1) >= 3
  }

  get encounterLocked() : boolean
  {
    return (this.encounter?.status ?? -1) >= 5
  }

  billForEdit: IMedicalBill | undefined;
  newBillForEdit: IMedicalBill | undefined;
  editIndex: number = -1;
  editingMedicalBill: boolean = false;
  editingNewBill = false;

  // medicalBill : IMedicalBill | undefined = {} as IMedicalBill;
  medicalBills : (IMedicalBill | undefined) [] = [];
  
  getMedicalBill(id: number) : IMedicalBill | undefined
  {
    return this.medicalBills.find(b => b?.id == id);
  }

  generateBillImageMenuItems(bill: IMedicalBill) : MenuItem[]
  {
    return [
      { label: 'Remove',disabled:this.encounterLocked, icon: 'pi pi-trash',command: () => this.clearBillImage(bill) },
      { label: 'View',icon: 'pi pi-eye', command: () => this.viewBillImage(bill) }
    ];
  }
  generateBillReportMenuItems(bill: IMedicalBill) : MenuItem[]
  {
    return [
      { label: 'Remove',disabled:this.encounterLocked, icon: 'pi pi-trash',command: () => this.clearBillReport(bill) },
      { label: 'View',icon: 'pi pi-eye', command: () => this.viewBillReport(bill) }
    ];
  }


  constructor(private _locationService: LocationService, 
              private _encounterService: EncounterService,
              private _utilService: UtilService,
              private _medicalService: TealCompMedicalService,
              private _messages: MessageService,
              private _store: Store)
  {
    
  }

  async createBillFromUpload(event:FileUploadHandlerEvent)
  {
    var files = event.files;
    if(files && files.length > 0)
    {
      this._store.dispatch(new BlockUI.BlockUI());
      if(this.encounter)
      {
        var newBill = await this._encounterService.addMedicalBillFromFile(this.encounter.id,files[0]);

        // if(this.medicalBills.length > 0 && this.medicalBills[0] == undefined)
        // {
        //   //new primary bill
        //   this.medicalBills[0] = newBill;
        // }
        // else
        // {
        //   //Add a new bill to the encounter
        //   this.medicalBills = [... this.medicalBills, newBill];
        // }

        this._store.dispatch(new BlockUI.UnBlockUI());
      }
    }
  }


  async uploadBillImage(event:FileUploadHandlerEvent, bill:IMedicalBill)
  {
    var files=event.files;
    //We only allow single upload

    if(files && files.length > 0 && bill)
      var billFile = await this._medicalService.setMedicalBillImage(bill.id,files[0]);

  }

  async uploadBillReport(event:FileUploadHandlerEvent, bill:IMedicalBill)
  {
    var files=event.files;
    //We only allow single upload

    if(files && files.length > 0 && bill)
      var billFile = await this._medicalService.setMedicalBillReport(bill.id,files[0]);

  }

  async clearBillImage(bill:IMedicalBill)
  {
    if(bill)
      await this._medicalService.clearMedicalBillImage(bill.id);
  }

  async clearBillReport(bill:IMedicalBill)
  {
    if(bill)
      await this._medicalService.clearMedicalBillReport(bill.id);
  }

  async viewBillImage(bill:IMedicalBill)
  {
    if(bill && bill.medicalBillImage)
    {
      var blob = await this._utilService.getFileBlob(bill.medicalBillImage)
      let url = window.URL.createObjectURL(blob);
        let pwa = window.open(url);
    }
  }

  async viewBillReport(bill:IMedicalBill)
  {
    if(bill && bill.medicalBillProviderReport)
    {
      var blob = await this._utilService.getFileBlob(bill.medicalBillProviderReport)
      let url = window.URL.createObjectURL(blob);
        let pwa = window.open(url);
    }
  }


  private generateNewBill() : IMedicalBill
  {
    var bill = {} as IMedicalBill;
    bill.id = Math.min(...this.medicalBills.map(b => b?.id ?? 0),0) -1;
    return bill;
  }

  createNewBill(event:MouseEvent)
  {
    if(this.encounter)
    {

      const newBill = this.generateNewBill();
      this.beginNewEdit(newBill);
    }
  }

  beginNewEdit(bill:IMedicalBill)
  {
    this.newBillForEdit = bill;
    this.editingNewBill = true;
    setTimeout( () => this.editDiv.nativeElement.scrollIntoView({behavior: "smooth", block:"center"}), 0);

  }

  beginEdit(bill: IMedicalBill, index:number)
  {
    this.billForEdit = plainToInstance(MedicalBill,bill);
    this.editingMedicalBill = true;
    this.editIndex = index;

    setTimeout( () => this.editDiv.nativeElement.scrollIntoView({behavior: "smooth", block:"center"}), 0);

  }

  async removeMedicalBill(bill: IMedicalBill)
  {
    //Block the UI
    this._store.dispatch(new BlockUI.BlockUI());
    //First, find out which bill this is
    var i = this.medicalBills.findIndex(b => b?.id == bill.id);
    
    if(i == 0)
    {
      this.medicalBills[0] = undefined;
    }
    else
    {
      this.medicalBills = [...this.medicalBills.filter(b => b?.id != bill.id)];
    }

    if(this.encounter && bill.id > 0)    
    {
      if(i == 0) //It's the first/primary bill
      {
        await this._encounterService.clearMedicalBill(this.encounter.id);
      }
      else
      {
        await this._encounterService.deleteAdditionalMedicalBill(this.encounter.id, bill.id);
      }
    }

    this._store.dispatch(new BlockUI.UnBlockUI());
  }

  newBillCancelled()
  {
    this.newBillForEdit = undefined;
    this.editingNewBill = false;
  }

  editCancelled()
  {
    this.billForEdit = {} as IMedicalBill;
    this.editingMedicalBill = false;
    this.editIndex = -1;
  }

  async newBillSaved(bill: IMedicalBill)
  {
    if(this.medicalBills.length > 0 && this.medicalBills[0] == undefined)
    {
      //new primary bill
      this.medicalBills[0] = bill;
      this.editIndex = 0;
      
    }
    else
    {
      this.editIndex = this.medicalBills.length
      //Add a new bill to the encounter
      this.medicalBills = [... this.medicalBills, bill];
    }
    await this.billSaved(bill);
  }

  async billSaved(bill: IMedicalBill)
  {
    //Block the UI
    this._store.dispatch(new BlockUI.BlockUI());
    try
    {
      if
      (
          bill &&
          bill.insuredAddress && 
          bill.servicingProvider && 
          bill.billingProvider &&
          bill.patient &&
          bill.patientAddress && 
          this.encounter
        ) 
      {

        //Are we updating or inserting?
        if (!bill.id || bill.id < 0) 
        {

          //Check the location stuff first
          var loc = new LocationInsert(bill.insuredAddress.street1,bill.insuredAddress.city, bill.insuredAddress.state, bill.insuredAddress.zipCode, bill.insuredAddress.street2)

          //This will insert a new location, or return one that already exists at this location
          var newLoc = await this._locationService.addLocation(loc);

          //New
          var bi = new MedicalBillInsert
          (
            bill.patient.id,
            bill.patientAddress.id,
            bill.phoneNumber,
            bill.gender,
            bill.patientAccountNumber,
            bill.insuredPhone,
            bill.insuredName,
            newLoc.id,
            new ProviderLocationIdentifier(bill.servicingProvider.facility.ein, bill.servicingProvider.facility.npi,bill.servicingProvider.location.id),
            new ProviderLocationIdentifier(bill.billingProvider.facility.ein, bill.billingProvider.facility.npi,bill.billingProvider.location.id),
            // bill.serviceBegin,
            // bill.serviceEnd
          )

          //Figure out our lines as well
          bi.billingLines = bill.lines.map(l => new MedicalBillLineInsert(l.procedure.id,l.units,l.modifiers?.map(m => m.code),l.dateOfService,l.cost,l.associatedDiagnosis?.map(d => d.code) ?? []));
          
          //If it's primary, set the bill
          if(this.editIndex == 0)
            await this._encounterService.setMedicalBill(this.encounter.id,bi);
          else
            await this._encounterService.addAdditionalMedicalBill(this.encounter.id,bi);

          this.billForEdit = {} as IMedicalBill;
          this.editingMedicalBill = false;
          this.editIndex = -1;
        }
      
        else
        {
          //Update
        
  
          let medicalBill = plainToInstance(MedicalBill,this.getMedicalBill(bill.id));

          var bu = new MedicalBillUpdate(bill.id);
          if(medicalBill?.patient?.id != bill.patient.id) bu.patientId = bill.patient.id;
          if(medicalBill?.patientAddress?.id != bill.patientAddress.id) bu.patientAddressId = bill.patientAddress.id;
          if(medicalBill?.patientAccountNumber != bill.patientAccountNumber) bu.patientAccountNumber = bill.patientAccountNumber;
          if(medicalBill?.phoneNumber != bill.phoneNumber) bu.phoneNumber = bill.phoneNumber;
          if(medicalBill?.gender != bill.gender) bu.gender = bill.gender;
          if(medicalBill?.billingProvider?.facility.ein != bill.billingProvider.facility.ein ||
              medicalBill?.billingProvider?.facility.npi != bill.billingProvider.facility.npi ||
              medicalBill?.billingProvider?.location.id != bill.billingProvider.location.id) bu.billingProvider =  new ProviderLocationIdentifier(bill.billingProvider.facility.ein, bill.billingProvider.facility.npi, bill.billingProvider.location.id);
          if(medicalBill?.servicingProvider?.facility.ein != bill.servicingProvider.facility.ein ||
              medicalBill?.servicingProvider?.facility.npi != bill.servicingProvider.facility.npi ||
              medicalBill?.servicingProvider?.location.id != bill.servicingProvider.location.id) bu.servicingProvider =  new ProviderLocationIdentifier(bill.servicingProvider.facility.ein, bill.servicingProvider.facility.npi, bill.servicingProvider.location.id);
          if(medicalBill?.insuredName != bill.insuredName) bu.insuredName = bill.insuredName;
          if(medicalBill?.insuredPhone != bill.insuredPhone) bu.insuredPhone = bill.insuredPhone;
          //See if we need to up date the address
          if
          (
            medicalBill?.insuredAddress?.city != bill.insuredAddress.city ||
            medicalBill?.insuredAddress?.state != bill.insuredAddress.state ||
            medicalBill?.insuredAddress?.street1 != bill.insuredAddress.street1 ||
            medicalBill?.insuredAddress?.street2 != bill.insuredAddress.street2 ||
            medicalBill?.insuredAddress?.zipCode != bill.insuredAddress.zipCode
          )
          {
            //Check the location stuff first
            var loc = new LocationInsert(bill.insuredAddress.street1,bill.insuredAddress.city, bill.insuredAddress.state, bill.insuredAddress.zipCode, bill.insuredAddress.street2)

            //This will insert a new location, or return one that already exists at this location
            var newLoc = await this._locationService.addLocation(loc);

            bu.insuredAddressId = newLoc.id;
          }

          //Handle the lines.
          //First, what's deleted:
          var existingLineIds = medicalBill?.lines?.map(l => l.id);
          var deletedLines = existingLineIds?.filter(l => !bill.lines.map(ll => ll.id).includes(l));
          var addedLines = bill.lines.filter(l => !existingLineIds?.includes(l.id))
            .map
            (
              l => new MedicalBillLineInsert(l.procedure.id,l.units,l.modifiers?.map(m => m.code),l.dateOfService,l.cost,l.associatedDiagnosis?.map(d => d.code) ?? [])
            );
          

          var updatedLines = bill.lines.filter(l => {
            const match = medicalBill?.lines.find(ll => ll.id == ll.id);
            if (!existingLineIds?.includes(l.id) || !match) return false;

            return (
              l.cost != match.cost ||
              l.dateOfService != match.dateOfService ||
              l.procedure.id != match.procedure.id ||
              l.units != match.units ||
              !this.checkDiagnoses(l.associatedDiagnosis,  match.associatedDiagnosis) ||
              JSON.stringify(l.modifiers) != JSON.stringify(match.modifiers)
            );
          }).map(l => {
            const match = medicalBill?.lines.find(ll => ll.id ==ll .id);
            const line = new MedicalBillLineUpdate(l.id);

            if (match) 
              {
              if (l.cost != match.cost) line.cost = l.cost;
              if (l.dateOfService != match.dateOfService) line.dateOfService = l.dateOfService;
              if (l.procedure.id != match.procedure.id) line.procedureId = l.procedure.id;
              if (l.units != match.units) line.units = l.units;

              if (!this.checkDiagnoses(l.associatedDiagnosis, match.associatedDiagnosis))
                line.associatedDiagnosisCodes = l.associatedDiagnosis?.map(d => d.code);

              if (JSON.stringify(l.modifiers) != JSON.stringify(match.modifiers))
                line.modifierCodes = l.modifiers?.map(m => m.code);
            }
            return line;
          });
          
          await this._medicalService.updateMedicalBill({billId:bu.id,medicalBill:bu,insertLines:addedLines,updateLines:updatedLines,deleteLines:deletedLines, encounterId: this.encounter.id});

          this.billForEdit = {} as IMedicalBill;
          this.editingMedicalBill = false;
          this._store.dispatch(new BlockUI.UnBlockUI());
        }
      }
    }
    catch(error)
    {
      if(error instanceof InvalidLocationError)
        this._messages.add({ key: 'main-alert', severity: 'error', summary: 'Could not Create Medical Bill', detail: 'Invalid Location'})
      else
        this._messages.add({ key: 'main-alert', severity: 'error', summary: 'Could not Create Medical Bill', detail: 'Unknown Error'})
    }
  }

  checkDiagnoses(d1: IDiagnosis[], d2: IDiagnosis[]) 
  {
    const d1Codes = d1.map(d => d.code).sort();
    const d2Codes = d2.map(d => d.code).sort();
    return JSON.stringify(d1Codes) == JSON.stringify(d2Codes);
  }

}
